import React, { useEffect } from 'react'
import { useMutateAssetSbisSend } from '../../../api/react-query/assets'
import { Checkbox, message, Modal } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'

const { confirm } = Modal

export default function AssetSendSbis ({ assetId, sendSbis }) {
  const {
    mutate,
    data,
    isSuccess,
    isError,
    isLoading
  } = useMutateAssetSbisSend()

  const handleChange = (e) => {
    const checked = e.target.checked
    confirm({
      title: 'Подтвердите действие',
      icon: <ExclamationCircleFilled />,
      content: checked
        ? 'Включить отправку данных в СБИС?'
        : 'Отключить отправку данных в СБИС?',
      okButtonProps: { loading: isLoading },
      onOk () {
        mutate({
          assetId,
          switchState: checked
        })
      }
    })
  }

  useEffect(() => {
    if (isSuccess && data?.success) {
      message.success('Данные успешно сохранены')
    } else if (isError || data?.errorMessage) {
      message.error(data?.errorMessage || 'Ошибка при сохранении данных')
    }
  }, [isSuccess, isError, data])

  return (
    <Checkbox checked={sendSbis} onChange={handleChange} disabled={isLoading} />
  )
}
